import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { CustomValidator, CustomValidatorMessage } from '../../../../core/helpers/customvalidators';
import { GenericService } from '../../../../core/services/generic.service';
import { getAuthError, getUserDataLoading } from '../../../../store/Authentication/authentication-selector';
import { changePassword } from '../../../../store/Authentication/authentication.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'app-changepassworddialog',
  templateUrl: './changepassworddialog.component.html',
  styleUrl: './changepassworddialog.component.scss'
})
export class ChangepassworddialogComponent {

  // Login Form
  passcreateForm!: UntypedFormGroup;
  submitted = false;
  currentField!: boolean;
  passwordField!: boolean;
  confirmField!: boolean;
  error = '';
  returnUrl!: string;
  ispasswordupdating : boolean = false;

  errormsgs = CustomValidatorMessage;

  constructor(private formBuilder: UntypedFormBuilder, private store: Store, private genericService: GenericService) { }

  ngOnInit(): void {
    /**
     * Form Validatyion
     */
     this.passcreateForm = this.formBuilder.group({
      currentpassword: ['', Validators.required, ...CustomValidator.PASSWORD_VALIDATION],
      password: ['', [Validators.required, ...CustomValidator.PASSWORD_VALIDATION]],
      cpassword: ['', Validators.required],
    },
    {
      validator: this.genericService.matchValidator('password', 'cpassword'),
    });

      // Password Validation set
      var myInput = document.getElementById("password-input") as HTMLInputElement;
      var letter = document.getElementById("pass-lower");
      var capital = document.getElementById("pass-upper");
      var number = document.getElementById("pass-number");
      var length = document.getElementById("pass-length");

      // When the user clicks on the password field, show the message box
      myInput.onfocus = function () {
        let input = document.getElementById("password-contain") as HTMLElement;
        input.style.display = "block"
      };

      // When the user clicks outside of the password field, hide the password-contain box
      myInput.onblur = function () {
        let input = document.getElementById("password-contain") as HTMLElement;
        input.style.display = "none"
      };

      // When the user starts to type something inside the password field
      myInput.onkeyup = function () {
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
            letter?.classList.remove("invalid");
            letter?.classList.add("valid");
        } else {
            letter?.classList.remove("valid");
            letter?.classList.add("invalid");
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
            capital?.classList.remove("invalid");
            capital?.classList.add("valid");
        } else {
            capital?.classList.remove("valid");
            capital?.classList.add("invalid");
        }

        // Validate numbers
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
            number?.classList.remove("invalid");
            number?.classList.add("valid");
        } else {
            number?.classList.remove("valid");
            number?.classList.add("invalid");
        }

        // Validate length
        if (myInput.value.length >= 8) {
            length?.classList.remove("invalid");
            length?.classList.add("valid");
        } else {
            length?.classList.remove("valid");
            length?.classList.add("invalid");
        }
      };

      this.store.select(getUserDataLoading).pipe(untilDestroyed(this)).subscribe((loading) => {
        this.ispasswordupdating = loading;
        if(!loading){
          this.passcreateForm.enable();
        }
      });

      this.store.select(getAuthError).pipe(untilDestroyed(this)).subscribe((error) => {
        if(error){
          this.ispasswordupdating = false;
          this.passcreateForm.enable();
        }
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.passcreateForm.controls; }

  /**
   * Form submit
   */
   onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.passcreateForm.invalid) {
      return;
    } else {
      this.passcreateForm.disable();
      this.store.dispatch(changePassword({ password: this.f['password'].value, currentpassword: this.f['currentpassword'].value }));
    }
  }

  /**
   * Password Hide/Show
   */
   togglepasswordField() {
    this.passwordField = !this.passwordField;
  }

  /**
 * Password Hide/Show
 */
  toggleconfirmField() {
    this.confirmField = !this.confirmField;
  }

  /**
 * Password Hide/Show
 */
  togglecurrentField() {
    this.currentField = !this.currentField;
  }

  ngOnDestroy(){
    console.log("inside ng destroy");
    this.passcreateForm.reset();
    this.passcreateForm.enable();
  }

}
